import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const ThumbDownIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                fill={props.fill || "currentColor"}
                stroke="none"
                d="M 3.54125 8.696 L 3.584455 8.516 L 4.09895 6.4163 L 0.01571 6.4163 L 0 5.60872 L 0 4.876355 L 0.003927 4.71977 C 0.003927 4.71977 0.047129 4.621135 0.062839 4.574285 L 1.441375 1.51167 L 1.70975 1 L 2.28185 1 L 9.6 1.001233 L 9.6 6.4163 L 7.34565 6.4163 L 4.152625 9.4 L 3.539945 8.696 L 3.54125 8.696 Z M 4.368635 8.271851 L 6.63345 6.1475 L 6.63345 6.1389 L 6.6374 6.1389 L 6.6374 1.657155 L 2.147005 1.657155 L 2.085475 1.77675 L 0.69647 4.8369 L 0.69647 5.761605 L 0.856185 5.761605 L 4.97739 5.761605 L 4.367325 8.2731 L 4.368635 8.271851 Z M 7.33255 5.761605 L 8.90485 5.761605 L 8.90485 1.657155 L 7.33255 1.657155 L 7.33255 5.761605 Z"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const ThumbDownIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                fill={props.fill || "currentColor"}
                stroke="none"
                d="M 3.54125 8.696 L 3.584455 8.516 L 4.09895 6.4163 L 0.01571 6.4163 L 0 5.60872 L 0 4.876355 L 0.003927 4.71977 C 0.003927 4.71977 0.047129 4.621135 0.062839 4.574285 L 1.441375 1.51167 L 1.70975 1 L 2.28185 1 L 9.6 1.001233 L 9.6 6.4163 L 7.34565 6.4163 L 4.152625 9.4 L 3.539945 8.696 L 3.54125 8.696 Z M 4.368635 8.271851 L 6.63345 6.1475 L 6.63345 6.1389 L 6.6374 6.1389 L 6.6374 1.657155 L 2.147005 1.657155 L 2.085475 1.77675 L 0.69647 4.8369 L 0.69647 5.761605 L 0.856185 5.761605 L 4.97739 5.761605 L 4.367325 8.2731 L 4.368635 8.271851 Z M 7.33255 5.761605 L 8.90485 5.761605 L 8.90485 1.657155 L 7.33255 1.657155 L 7.33255 5.761605 Z"
            />
        </SvgIcon>
    );
};
